/* eslint-disable */
import { Typography } from '@material-ui/core';
import React from 'react';
import { formatDate, fullDate } from 'Consts/DateFormats';

export default {
  id: {
    HeaderComponent: ({ attrName, className }) => (
      <Typography>{'Household ID'}</Typography>
    ),
    ColumnComponent: ({ resource, attrName }) => (
      <Typography>{resource.id()}</Typography>
    ),
  },
  householdName: {
    HeaderComponent: ({ attrName, className }) => (
        <Typography>{'Household Name'}</Typography>
    ),
    ColumnComponent: ({ resource, attrName }) => (
        <Typography>{resource.attr(attrName)}</Typography>
    ),
  },
  plannerName: {
    HeaderComponent: ({ attrName }) => (
        <Typography>{'Planner Name'}</Typography>
    ),
    ColumnComponent: ({ resource, attrName }) => (
        <Typography>{resource.selectedOptionPrompt(attrName)}</Typography>
    ),
  },
  renewalDate: {
    HeaderComponent: ({ attrName }) => (
        <Typography>{'Renewal Date'}</Typography>
    ),
    ColumnComponent: ({ resource, attrName }) => (
        <Typography>{formatDate(resource.attr(attrName), fullDate)}</Typography>
    ),
  },
  householdStatus: {
    HeaderComponent: ({ attrName }) => (
        <Typography>{'Household Status'}</Typography>
    ),
    ColumnComponent: ({ resource, attrName }) => (
        <Typography>{resource.selectedOptionPrompt(attrName)}</Typography>
    ),
  },
  transitionDate: {
    HeaderComponent: ({ attrName }) => (
        <Typography>{'Transition Date'}</Typography>
    ),
    ColumnComponent: ({ resource, attrName }) => (
        <Typography>{resource.attr(attrName)}</Typography>
    ),
  },
  nextMeetingDate: {
    HeaderComponent: ({ attrName }) => (
        <Typography>{'Next Meeting Date'}</Typography>
    ),
    ColumnComponent: ({ resource, attrName }) => (
        <Typography>{resource.attr(attrName) ? formatDate(resource.attr(attrName), fullDate) : ''}</Typography>
    ),
  },
  currentCycleAccomplishmentCount: {
    HeaderComponent: ({ attrName }) => (
      <Typography>{'Current Cycle Accomplishments'}</Typography>
    ),
    ColumnComponent: ({ resource, attrName }) => (
      <Typography>{resource.attr(attrName)}</Typography>
    ),
  },
  accomplishmentCount: {
    HeaderComponent: ({ attrName }) => (
      <Typography>{'Accomplishments'}</Typography>
    ),
    ColumnComponent: ({ resource, attrName }) => (
      <Typography>{resource.attr(attrName)}</Typography>
    ),
  },
  futureAccomplishmentCount: {
    HeaderComponent: ({ attrName }) => (
      <Typography>{'Future Accomplishments'}</Typography>
    ),
    ColumnComponent: ({ resource, attrName }) => (
      <Typography>{resource.attr(attrName)}</Typography>
    ),
  },
  paymentSwitch: {
    HeaderComponent: ({ attrName }) => (
        <Typography>{'Payment Switch'}</Typography>
    ),
    ColumnComponent: ({ resource, attrName }) => (
        <Typography>{resource.attr(attrName)}</Typography>
    ),
  },
};
/* eslint-enable */
